module.exports = __webpack_public_path__ + "img/loading-green.ab24560a.svg";